import * as React from "react";

const SVGComponent = (props) => (
    <svg
        fill='none'
        height={48}
        viewBox='0 0 32 32'
        width={48}
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M5.11943 1.29858L5.3711 3.81528L17.3497 1.64962C18.7302 1.40003 20 2.46085 20 3.86373V5.239L27.4527 4.24534C28.8015 4.0655 30 5.11483 30 6.47561V19.1582C30 20.2529 29.2122 21.1887 28.1335 21.3753L16.6962 23.3536C14.5236 23.7294 13.163 21.0802 14.7341 19.5333L15.0012 19.2704L7.06097 20.714L8.03485 30.4528L5.54726 30.7016L2.63184 1.54734L5.11943 1.29858ZM17.5 8.62012V4.16298L12 5.15734V9.65241L17.5 8.62012ZM17.5 12.7696L12 13.6117L12 9.65241L6.06618 10.7661L6.43592 14.4635L12 13.6117L12 17.275L17.5 16.275V12.7696ZM20 11.9468L23.9999 11.4183L23.9999 16.0735L20 16.6044V16.9146C20 17.5174 19.7581 18.095 19.3286 18.5179L17.0576 20.754L23.9999 19.5532V16.0735L27.5 15.609V10.9559L23.9999 11.4183V7.22782L20 7.76112V11.9468Z'
            fill='currentColor'/>
    </svg>
);

export default SVGComponent;
